import { Component, Input, OnInit } from '@angular/core';
import { QuotationService } from 'src/app/quotation.service';

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.css']
})
export class ProductDetailsComponent implements OnInit {
  @Input('ProductValues') ProductValues : any;
  constructor( private quotionService : QuotationService ) { }

  ngOnInit(): void {
    //this.quotionService.onTotal();
  }
   
  print() {
    window.print();
    }

}
